module.exports = __webpack_public_path__ + "static/img/EU_EAKR_EN_vertical_20mm_rgb.4a81b63.png";